/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JumboStructsMFADisabledUser } from './JumboStructsMFADisabledUser';
import {
    JumboStructsMFADisabledUserFromJSON,
    JumboStructsMFADisabledUserFromJSONTyped,
    JumboStructsMFADisabledUserToJSON,
} from './JumboStructsMFADisabledUser';

/**
 * 
 * @export
 * @interface JumboGetusersmfadisabledGetUsersMFADisabledResponse
 */
export interface JumboGetusersmfadisabledGetUsersMFADisabledResponse {
    /**
     * 
     * @type {Array<JumboStructsMFADisabledUser>}
     * @memberof JumboGetusersmfadisabledGetUsersMFADisabledResponse
     */
    users?: Array<JumboStructsMFADisabledUser>;
}

/**
 * Check if a given object implements the JumboGetusersmfadisabledGetUsersMFADisabledResponse interface.
 */
export function instanceOfJumboGetusersmfadisabledGetUsersMFADisabledResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetusersmfadisabledGetUsersMFADisabledResponseFromJSON(json: any): JumboGetusersmfadisabledGetUsersMFADisabledResponse {
    return JumboGetusersmfadisabledGetUsersMFADisabledResponseFromJSONTyped(json, false);
}

export function JumboGetusersmfadisabledGetUsersMFADisabledResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetusersmfadisabledGetUsersMFADisabledResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'users': !exists(json, 'users') ? undefined : ((json['users'] as Array<any>).map(JumboStructsMFADisabledUserFromJSON)),
    };
}

export function JumboGetusersmfadisabledGetUsersMFADisabledResponseToJSON(value?: JumboGetusersmfadisabledGetUsersMFADisabledResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'users': value.users === undefined ? undefined : ((value.users as Array<any>).map(JumboStructsMFADisabledUserToJSON)),
    };
}

